<template>
  <ClicColInterno :cp="cp" :key="componentKey">
    <div
      :ref="scrollContainerRef"
      @scroll="manipularRolagem"
      @touchmove="manipularRolagemMobile"
      :style="obterTamanhoContainer"
    >

      <b-col v-if="scrollToTop && configAxiosContent" class="bg-white p-2">
        <p 
          class="text-center mt-4" 
          v-if="ultimaPagina && this.items && this.items.length > 0"
        >
          Exibindo todos os resultados
        </p>
        <p 
          class="text-center d-flex justify-content-center mt-4" 
          v-if="items && items.length === 0 && !isLoading"
        >
          {{noDataMessage}}
        </p>
        <b-overlay 
          :show="isLoading && !ultimaPagina"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="text-center"
        />
      </b-col>

      <!-- Lista Otimizada -->
      <template v-if="optimizedList">
        <div class="wrapper">
          <RecycleScroller
            :items="items"
            :item-size="itemSize"
            v-slot="{ item, index }"
            :key-field="keyFieldForScroller"
            class="scroller"
            :style="{ maxHeight: maxHeight, overflowY: 'auto', overflowX: 'hidden' }" 
            ref="scroller"
            @scroll-start="onScrollStart"
            @scroll-end="onScrollEnd"
            :prerender="10"
            >
            <div 
              @click="click(item)" 
              :key="item[keyFieldForScroller]"
              :style="
                itemStyle || {
                  height: `${itemSize}px`,
                  borderBottom: '6px solid #f5f6fa !important',
                }
              "
            >
              <MotorS 
                :cp="cp" 
                :childrens="childrens"
                :idTela="idTela"
                :state="{ row: {item, index: item[keyFieldForScroller], lineNumber: index + 1}, parent: {...cp,  optimizedList}}"
              />
            </div>
          </RecycleScroller>
          </div>
      </template>
      
      <!-- Lista Default -->
      <template v-else>
        <b-list-group :flush="true">  
          <b-list-group-item 
            @click="click(item)" 
            :id="$utils.getComponentID(cp.id)"
            v-for="(item, index) in items" 
            :key="index"
            :style="itemStyle || 'cursor: pointer;'"
          >
            <MotorS 
              :cp="cp" 
              :childrens="childrens"
              :idTela="idTela"
              :state="{ row: {item, index}, parent: cp}"
            />
          </b-list-group-item>
        </b-list-group>
      </template>

      <b-col v-if="!scrollToTop && configAxiosContent" class="bg-white p-2">
        <p 
          class="text-center mt-4" 
          v-if="ultimaPagina && this.items && this.items.length > 0"
        >
          Exibindo todos os resultados
        </p>
        <p 
          class="text-center d-flex justify-content-center mt-4" 
          v-if="items && items.length === 0 && !isLoading"
        >
        {{noDataMessage}}
        </p>
        <b-overlay 
          :show="isLoading && !ultimaPagina"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="text-center"
        />

      </b-col>   
    </div>
    
  </ClicColInterno>
</template>

<script>
import ComponentMixin from '../../core/ComponentMixin';
import { clearRowUiProps } from '../../core/rowUiState';
import { BCol, BOverlay, BListGroup, BListGroupItem } from 'bootstrap-vue';

export default {
  name: 'ClicList',
  mixins: [ComponentMixin],
  components: { BCol, BOverlay, BListGroup, BListGroupItem },
  data() {
      return {
        public : {
          dataRefresh                : this.atualizarConsulta,
          updateRecycleScroller      : this.updateRecycleScroller,
          getSelectedRow             : this.obterLinhaSelecionada,
          unshift                    : this.unshift,
          push                       : this.push,
          remove                     : this.remove,
        },
        alturaLista                  : 'calc(100% - 10px)',
        paginaAtual                  : 1,
        isLoading                    : true,
        novosItens                   :[],
        ultimaPagina                 : false,
        filtroAntigo                 : "",
        paramsAntigo                 : "",
        scrollContainerRef           : `scrollContainerClicList-${this.cp.id}`,
        linhaSelecionada             : undefined,   
        tamanhoMargemRolagem         : 800,
        tamanhoMargemRolagemMobile   : 250,

        items                        : [],
        optimizedList                : false,
        scrollStartAlreadyTriggered  : true
      };
  },
 
  created(){
    this.items = []
  },
  async mounted() {
    this.defineListType();

    if(this.configAxiosContent){
      this.resetarBuscaServidor();
    };

    await this.atualizarConsulta();
    
    if(this.configAxiosContent){
      this.calcularTamanhoContainerLista();
    };  
  },


  computed: { 
    obterTamanhoContainer() {
      const { configAxiosContent, cp } = this;
      const containerStyle = this.lodash.get(cp, "props.containerStyle", false);
      
      if (configAxiosContent) {
        if (containerStyle && containerStyle != "") {
          return `height: 100%; overflow-y: auto;`;
        } else {
          return `height: ${this.alturaLista}; overflow-y: auto;`;
        };
      };
      
      return '';
    }
  },

  beforeDestroy() {
    clearRowUiProps(this.cp?.id);
  },

  methods: {
    onScrollStart(){
      if(this.scrollStartAlreadyTriggered){
        this.scrollStartAlreadyTriggered = false
      }else{
        this.manipularRolagem({firstItemRendered: true});
      }
    },
    onScrollEnd(){
      this.manipularRolagem({lastItemRendered: true});
    },
    defineListType(){
      if (this.keyFieldForScroller) {
        this.optimizedList = true;
      } else {
        this.optimizedList = false;
      }
    },
    unshift(item) {
      if (Array.isArray(item)) {
        this.items.unshift(...item); 
      } else {
        this.items.unshift(item); 
      }
    },
    push(item) {
      if (Array.isArray(item)) {
        this.items.push(...item); 
      } else {
        this.items.push(item); 
      }
    },
    remove(item, prop) {
      if (Array.isArray(item)) {
        item.forEach(i => {
          const index = this.items.findIndex(el => el[prop] === i[prop]);
          if (index !== -1)  {
            this.items.splice(index, 1);
          }
        });
      } else {
        const index = this.items.findIndex(el => el[prop] === item[prop]);
        if (index !== -1) {
          this.items.splice(index, 1);
        }
      }
      this.items = [...this.items]
    }, 
    updateRecycleScroller(){
        this.componentKey = this.$utils.getComponentID();
    },
    obterLinhaSelecionada(){
      return this.linhaSelecionada;
    },

    click(row) {
      this.linhaSelecionada = row;

      if  (this.lodash.has(this.cp, 'events.click')) {
        this._execEvent('click', { row });
        
      } else if (this.lodash.has(this.cp, 'events.clickPromise')) {
        this.isLoading = true;
        this._execEventPromise('clickPromise', { row })
          .then(() => {
            this.isLoading = false;
          });
      }
    },

    async atualizarConsulta(){
      try {
        this.isLoading  = true;
        this.items      = await this.obterDadosLista();

        this.calcularTamanhoContainerLista();
      
      } catch (e) {
        console.error(`[ClicList] Falha ao atualizar a consulta. Detalhes: ${e}`);
      } finally {
        this.isLoading  = false;
      }      
    },

    resetarBuscaServidor(){
      this.paginaAtual                      = 1;
      this.configAxiosContent.params.fetch  = this.itemsPerPage;
      this.configAxiosContent.params.skip   = 0;
      this.ultimaPagina                     = false;
      this.novosItens                       = [];
      this.items                            = [];
    },

    obterDadosLista() {
      return new Promise((resolve, reject) => {

        if (this.items && !this.configAxiosContent) {
          
          this.isLoading = false;
          resolve(this.items);

        } else if (this.configAxiosContent) {

          if(this.filtroEstaAtivo() || this.detectarAlteracaoNosParams()){
            this.filtroAntigo = this.configAxiosContent.params.filter;
            this.paramsAntigo = this.configAxiosContent.params;
            this.resetarBuscaServidor();

          }else if(this.filtroAntigo != "" && !this.configAxiosContent.params.filter ){
            this.filtroAntigo = ""
            this.items = [];

          };
            
          let axios = this.configAxiosContent;
          const tipoParametro = this.lodash.get(axios, 'method', 'GET').toUpperCase() == 'GET' ? 'params' : 'data';
          
          axios[tipoParametro].sortBy       = this.sortBy;
          axios[tipoParametro].sortDescAsc  = !this.sortDesc ? 'ASC' : 'DESC';
          axios[tipoParametro].keysFilter   = this.keysFilter;
          axios[tipoParametro].fetch        = this.itemsPerPage;

          this.$axios(axios).then(response => {     
            const pathDados                 = (this.pathItems && this.pathItems.length) ? `data.${this.pathItems}` : 'data';
            this.novosItens                 = this.lodash.get(response, pathDados, []);  

            if(this.novosItens && this.novosItens.length){
              this.ultimaPagina = false;
              
              if(this.scrollToTop){
                this.items.unshift(...this.novosItens);
                this.componentKey += 1; // ajustar

              }else{
                this.items.push(...this.novosItens);
              };

              if(this.primeiraPagina()){
                this.componentKey += 1;
              };

            }else{
              this.ultimaPagina = true;
            };
            
            this.isLoading = false;
            
            resolve(this.items);
          }).catch(erro => {
            console.error(`[ClicList] Falha ao consultar a API. Detalhes: ${erro}`);
            this.ultimaPagina = true;
            this.isLoading = false;
            resolve(this.items);
          });          
        }else{
          this.isLoading = false;
          resolve(this.items);
        }          
      });
    },

    mudarPagina(novaPagina) {
      if (this.configAxiosContent) {
        this.paginaAtual  = novaPagina;
        this.configAxiosContent.params.fetch  = this?.itemsPerPage;
        let skip                              = (this.paginaAtual-1) * this.itemsPerPage;

        if (skip != this.configAxiosContent.params.skip){
          this.configAxiosContent.params.skip = skip;          
        }
        this.atualizarConsulta();
      };
    },

    manipularRolagem(params) {
      if(this.configAxiosContent){
        const { firstItemRendered = false, lastItemRendered = false } = params;

        let scrollContainer   = this.$refs[this.scrollContainerRef];
        const margin          = this.primeiraPagina() || this.ultimaPagina ? 5 : this.tamanhoMargemRolagem;    
        const topoContainer   = ((scrollContainer.scrollTop) === 0) || firstItemRendered;
        const rodapeContainer = (scrollContainer.scrollTop + scrollContainer.clientHeight + margin >= scrollContainer.scrollHeight) || lastItemRendered;


        if(topoContainer && this.scrollToTop && !this.ultimaPagina && !this.isLoading){
          this.scrollStartAlreadyTriggered = true
          this.mudarPagina(this.paginaAtual+1);
        };
        if(rodapeContainer && !this.scrollToTop && !this.ultimaPagina && !this.isLoading){
          this.mudarPagina(this.paginaAtual+1);
        };
      }
 
    },

    manipularRolagemMobile(event) {
      if(this.configAxiosContent){
        const scrollContainer = this.$refs[this.scrollContainerRef];
        const margin          = this.primeiraPagina() || this.ultimaPagina ? 5 : this.tamanhoMargemRolagemMobile;

        if (!this.scrollToTop && scrollContainer.scrollTop + scrollContainer.clientHeight + margin >= scrollContainer.scrollHeight) {
          this.mudarPagina(this.paginaAtual+1);
        };
      }
    },

    calcularTamanhoContainerLista() {
      const scrollContainer = this.$refs[this.scrollContainerRef];

      if (this.primeiraPagina()) {
        this.alturaLista = `${scrollContainer.scrollHeight - 25}px`;

      }else{
        this.alturaLista = this.alturaLista;
      }
    
      if(this.scrollToTop){        
        scrollContainer.scrollTop = ( scrollContainer.scrollHeight / this.paginaAtual);
      };

    },

    primeiraPagina(){
      return this.paginaAtual === 1;
    },

    filtroEstaAtivo() {
      return this.configAxiosContent.params.filter  &&
        this.configAxiosContent.params.filter != "" &&
        this.filtroAntigo != this.configAxiosContent.params.filter;
    },


    detectarAlteracaoNosParams() {
      const params = this.configAxiosContent.params;
      
      for (let prop of this.filterPropsToCompare) {
        const valorNovo = JSON.stringify(params[prop]);
        const valorAntigo = JSON.stringify(this.paramsAntigo[prop]);

        if (valorNovo !== valorAntigo) {
          return true;
        }
      }

      return false;
    }

  },

};
</script>

<style>
.card-body {
  padding-top: 0;
}

.recycle-scroller-demo:not(.page-mode) {
  height: 100%;
}

.recycle-scroller-demo.page-mode:not(.full-page) {
  height: 100%;
}

.recycle-scroller-demo.page-mode {
  flex: auto 0 0;
}

.recycle-scroller-demo.page-mode .toolbar {
  border-bottom: solid 1px #e0edfa;
}



.recycle-scroller-demo.page-mode:not(.full-page) .content {
  overflow: auto;
}

.recycle-scroller-demo:not(.page-mode) .wrapper {
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.scroller {
  width: 100%;
  height: 100%;
}

.vue-recycle-scroller {
  -webkit-overflow-scrolling: touch;
}

.vue-recycle-scroller__item-container,
.vue-recycle-scroller__item-wrapper {
  box-sizing: border-box;
}

.vue-recycle-scroller__item-view {
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}



.vue-recycle-scroller__item-view .tr {
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.vue-recycle-scroller__item-view .td {
  box-sizing: border-box;
  display: block;
}

.vue-recycle-scroller__item-view.hover {
  background: #f5f6fa;
  z-index: 60;
}



</style>
